export const BEGIN_PLACEHOLDER = '{periodBegin}';
export const END_PLACEHOLDER   = '{periodEnd}';